<div class="label" [class.somtoday]="instelling.bron === InstellingBron.Somtoday" [class.magister]="instelling.bron === InstellingBron.Magister">
	{{ instelling.bron }}
</div>
@if (toonBestuur && instelling.bestuur) {
	<div class="label bestuur">{{ instelling.bestuur.naam }}</div>
}
@if (toonVSO && instelling.vso) {
	<div class="label vso">VSO</div>
}
